module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_9016.3eb9dee2.png";